
const BASE = '/app/admins';

export const ADMINS_GROUP_LINKS = {
	BASE,
	LINK_ADMIN_DETAILS: BASE.concat('/:id'),
	LINK_ADMIN_CREATE: BASE.concat('/create')
};